// extracted by mini-css-extract-plugin
module.exports = {"container":"text-editor_container__2BZCW","invert":"text-editor_invert__1V2F8","editIcon":"text-editor_editIcon__1-8Pj"};